import React, { useContext } from "react";

import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import breakpoints from "../../constants";
import Markdown from "../../styles/Markdown";

const StyledMotto = styled.div`
  font-size: 2rem;
  color: ${({ color }) => color || "#fff"};
  font-weight: bold;

  @media (min-width: ${breakpoints.DESKTOP}) {
    font-size: 3rem;
  }
`;

const StyledMottoWrapper = styled.div``;

const StyledHeroText = styled.div`
  z-index: 1;
`;

function HeroText() {
  const { color, text, minHeight } = useContext(ComponentContext);

  if (!text) {
    return null;
  }

  return (
    <StyledHeroText minHeight={minHeight}>
      <StyledMottoWrapper>
        <StyledMotto color={color}>
          <Markdown>{text}</Markdown>
        </StyledMotto>
      </StyledMottoWrapper>
    </StyledHeroText>
  );
}

export default HeroText;
